import React from "react";
import { Box, Sheet, Stack, Typography } from "@mui/joy";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { QCFinding } from "../../types/qcTypes";
import PanelQCResultsView from "./PanelQCResultsView";

interface QCSectionPanelProps {
  sectionTitle: string;
  sectionContent: string;
  findings: QCFinding[];
  onAcceptFinding: (
    findingId: number,
    editedText?: string | null,
  ) => void | Promise<void>;
  onDeclineFinding: (findingId: number) => void | Promise<void>;
  onRevertFinding?: (findingId: number) => void | Promise<void>;
  onAcceptAll: () => void | Promise<void>;
  onDeclineAll: () => void | Promise<void>;
  onRevertAll?: () => void | Promise<void>;
  onSubmitFeedback?: (
    findingId: number,
    helpful: boolean,
  ) => void | Promise<void>;
  readOnly?: boolean;
}

const QCSectionPanel: React.FC<QCSectionPanelProps> = ({
  sectionTitle,
  sectionContent,
  findings,
  onAcceptFinding,
  onDeclineFinding,
  onRevertFinding,
  onAcceptAll,
  onDeclineAll,
  onRevertAll,
  onSubmitFeedback,
  readOnly = false,
}) => {
  return (
    <Sheet
      variant="outlined"
      sx={{
        mb: 4,
        borderRadius: "md",
        overflow: "hidden",
        boxShadow: "md",
        borderWidth: 2,
        borderColor: "neutral.outlinedBorder",
        borderLeft: "4px solid",
        borderLeftColor: "primary.500",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          px: 2,
          py: 1.5,
          bgcolor: "background.level1",
          borderBottom: "2px solid",
          borderColor: "neutral.outlinedBorder",
        }}
      >
        <DescriptionOutlinedIcon sx={{ fontSize: 20, color: "primary.500" }} />
        <Typography
          level="title-md"
          sx={{ flex: 1, fontWeight: "lg", letterSpacing: "0.01em" }}
        >
          {sectionTitle}
        </Typography>
      </Stack>

      <Box sx={{ p: 2 }}>
        <PanelQCResultsView
          findings={findings}
          sectionContent={sectionContent}
          sectionTitle={sectionTitle}
          onAcceptFinding={onAcceptFinding}
          onDeclineFinding={onDeclineFinding}
          onRevertFinding={onRevertFinding}
          onAcceptAll={onAcceptAll}
          onDeclineAll={onDeclineAll}
          onRevertAll={onRevertAll}
          onSubmitFeedback={onSubmitFeedback}
          readOnly={readOnly}
        />
      </Box>
    </Sheet>
  );
};

export default QCSectionPanel;
